import Logo1 from "../../../assets/images/logo1.png";
import { useSelector } from "react-redux";
import moment from "moment";
import numeral from "numeral";
import { currencySymbol } from "../../../utils/constants";
import Logo2 from "../../../assets/images/logo2.svg";
import { useMemo } from "react";

const CreditPrintReportHeader = () => {
  const { creditPrintReport } = useSelector((state) => state);
  const brand = useMemo(() => new URLSearchParams(window.location.search).get("brand"), []);
  const _logo = brand === "DL1961" ? Logo1 : Logo2;
  const headerData = creditPrintReport && creditPrintReport?.payload?.data[0];

  let sumAmount = creditPrintReport?.payload?.data.reduce(function (
    previousValue,
    currentValue
  ) {
    return (previousValue += parseFloat(
      currentValue.net_amount
    ));
  },
    0);

  return (
    <div className="__header">
      <table width="100%">
        <tbody>
          <tr>
            <td width="100%" style={{ paddingRight: "5px" }}>
              <table width="100%">
                <tbody>
                  <tr>
                    <td>
                      <table width="100%">
                        <tbody>
                          <tr>
                            <td>
                              <div className="__image_container">
                                <img width={150} height={26} src={_logo} alt="Brand Logo" />
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td valign="top" width="100%">
                              <div className="__addr">
                                <p>DLPD CANADA LTD.</p>
                                <p>15 Wertheim Court, Suite 409,</p>
                                <p>Richmond Hill, ON L4B 3H7 , Canada</p>
                                <p>Business # : 763395530RT0001</p>
                                <p>Email : orderca@dl1961.com</p>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <table width="100%">
                        <tbody>
                          <tr>
                            <td>
                              <table width="100%" className="__addr_table">
                                <thead>
                                  <tr>
                                    <th>Customer</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>
                                      <p>
                                        {headerData && headerData.customer_name}
                                      </p>
                                      <p>
                                        {headerData && headerData.address_1}
                                      </p>
                                      <p>
                                        {headerData && headerData.address_2}
                                      </p>
                                      <p>
                                        {headerData && headerData.city_name + " " + headerData.state_name + " " + headerData.zip_code}
                                      </p>
                                      <p>
                                        {headerData && headerData.country_name}
                                      </p>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td className="__box_wrapper" valign="top" style={{ paddingLeft: "5px" }}>
              <table className="__box">
                <tbody>
                  <tr>
                    <td>Credit Memo#{headerData && headerData.memo_header_no}</td>
                  </tr>
                  <tr>
                    <td>
                      <div style={{ padding: '10px 0' }}>Date:{headerData && moment(headerData.memo_date).format("MM/DD/YYYY")}</div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p><span>TOTAL</span>{currencySymbol}{numeral(sumAmount).format("00.00")}</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default CreditPrintReportHeader;
